// extracted by mini-css-extract-plugin
module.exports = {"BannerRow":"style_BannerRow__1Fhr0"};